(function () {
  "use strict";

  var DESKTOP_MQ = window.matchMedia("(min-width: 768px)");
  var REDUCED_MOTION_MQ = window.matchMedia("(prefers-reduced-motion: reduce)");

  function heroRoot(el) {
    return el.closest(".b2b-hero");
  }

  function mediaEl(hero) {
    return hero ? hero.querySelector(".b2b-hero__media") : null;
  }

  function activeVideo(media) {
    if (!media) return null;

    var videos = media.querySelectorAll("video.b2b-hero__video");
    if (!videos.length) return null;

    var single = media.querySelector(".b2b-hero__video--single");
    if (single) return single;

    var desktop = media.querySelector(".b2b-hero__video--desktop");
    var mobile = media.querySelector(".b2b-hero__video--mobile");

    if (DESKTOP_MQ.matches) {
      return desktop || mobile || videos[0];
    }

    return mobile || desktop || videos[0];
  }

  function setMediaPlayingState(media, playing) {
    if (!media) return;
    media.classList.toggle("is-video-playing", playing);
  }

  function prepareVideo(video) {
    if (!video || REDUCED_MOTION_MQ.matches) return;

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.autoplay = true;
    video.setAttribute("autoplay", "");
    video.loop = true;
    video.setAttribute("loop", "");
  }

  function tryPlay(video) {
    if (!video || REDUCED_MOTION_MQ.matches) return Promise.resolve();

    prepareVideo(video);

    if (video.readyState === 0) {
      video.load();
    }

    var playPromise = video.play();
    if (!playPromise || typeof playPromise.then !== "function") {
      return Promise.resolve();
    }

    return playPromise.catch(function () {
      return undefined;
    });
  }

  function syncButton(btn, video) {
    if (!btn || !video) return;

    var playing = !video.paused && !video.ended;
    btn.dataset.playing = playing ? "true" : "false";
    btn.setAttribute("aria-label", playing ? "Pause video" : "Play video");
    btn.setAttribute("aria-pressed", playing ? "true" : "false");
  }

  function playHeroVideo(media, btn) {
    var video = activeVideo(media);
    if (!video) return Promise.resolve();

    return tryPlay(video).then(function () {
      syncButton(btn, video);
      setMediaPlayingState(media, !video.paused && !video.ended);
    });
  }

  function isVideoPaused(media) {
    var video = activeVideo(media);
    return !video || video.paused || video.ended;
  }

  function triggerPlayIfPaused(media, btn) {
    if (REDUCED_MOTION_MQ.matches || !isVideoPaused(media)) return;

    if (btn) {
      btn.click();
      return;
    }

    playHeroVideo(media, null);
  }

  function ensureHeroAutoplay(media, btn) {
    var key = btn ? "b2bHeroAutoplayEnsured" : "b2bHeroAutoplayEnsuredNoBtn";
    if (REDUCED_MOTION_MQ.matches || media.dataset[key]) return;
    media.dataset[key] = "true";

    function attempt() {
      triggerPlayIfPaused(media, btn);
    }

    attempt();
    window.requestAnimationFrame(attempt);
    [100, 350, 750, 1500].forEach(function (delay) {
      window.setTimeout(attempt, delay);
    });

    media.querySelectorAll("video.b2b-hero__video").forEach(function (el) {
      el.addEventListener("canplay", attempt);
      el.addEventListener("loadeddata", attempt);
      el.addEventListener("loadedmetadata", attempt);
    });

    window.addEventListener("load", attempt, { passive: true });
  }


  function bindVideoEvents(media, btn) {
    if (media.dataset.b2bHeroVideoBound) return;
    media.dataset.b2bHeroVideoBound = "true";

    var video = activeVideo(media);
    if (!video) return;

    function refresh() {
      video = activeVideo(media);
      if (!video) return;

      var playing = !video.paused && !video.ended;
      setMediaPlayingState(media, playing);
      syncButton(btn, video);
    }

    function onPlaying() {
      setMediaPlayingState(media, true);
      syncButton(btn, video);
    }

    function onPaused() {
      setMediaPlayingState(media, false);
      syncButton(btn, video);
    }

    media.querySelectorAll("video.b2b-hero__video").forEach(function (el) {
      prepareVideo(el);
      el.addEventListener("playing", onPlaying);
      el.addEventListener("pause", onPaused);
      el.addEventListener("ended", onPaused);
      el.addEventListener("loadeddata", refresh);
    });

    playHeroVideo(media, btn);
    refresh();
  }

  function bindToggle(btn) {
    if (btn.dataset.b2bHeroVideoBound) return;
    btn.dataset.b2bHeroVideoBound = "true";

    var hero = heroRoot(btn);
    var media = mediaEl(hero);
    if (!media) return;

    bindVideoEvents(media, btn);

    btn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      var video = activeVideo(media);
      if (!video) return;

      if (video.paused || video.ended) {
        playHeroVideo(media, btn);
      } else {
        video.pause();
        syncButton(btn, video);
        setMediaPlayingState(media, false);
      }
    });

    ensureHeroAutoplay(media, btn);

    function onBreakpointChange() {
      pauseInactiveVideos(media);
      playHeroVideo(media, btn);
      ensureHeroAutoplay(media, btn);
    }

    if (typeof DESKTOP_MQ.addEventListener === "function") {
      DESKTOP_MQ.addEventListener("change", onBreakpointChange);
    } else if (typeof DESKTOP_MQ.addListener === "function") {
      DESKTOP_MQ.addListener(onBreakpointChange);
    }
  }

  function pauseInactiveVideos(media) {
    if (!media) return;
    var current = activeVideo(media);
    media.querySelectorAll("video.b2b-hero__video").forEach(function (el) {
      if (el !== current && !el.paused) {
        el.pause();
      }
    });
  }

  function initAutoplayRetries() {
    if (window.__b2bHeroVideoRetriesBound || REDUCED_MOTION_MQ.matches) return;
    window.__b2bHeroVideoRetriesBound = true;

    function retryAll() {
      document.querySelectorAll(".b2b-hero__media--video").forEach(function (media) {
        var hero = media.closest(".b2b-hero");
        var btn = hero && hero.querySelector("[data-b2b-hero-video-toggle]");
        triggerPlayIfPaused(media, btn);
      });
    }

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") retryAll();
    });

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) retryAll();
    });

    window.addEventListener(
      "touchstart",
      function () {
        retryAll();
      },
      { once: true, passive: true }
    );

    window.addEventListener(
      "click",
      function () {
        retryAll();
      },
      { once: true, passive: true }
    );

    window.addEventListener("load", retryAll, { passive: true });
  }

  function init() {
    document.querySelectorAll("[data-b2b-hero-video-toggle]").forEach(bindToggle);

    document.querySelectorAll(".b2b-hero__media--video").forEach(function (media) {
      if (media.closest(".b2b-hero").querySelector("[data-b2b-hero-video-toggle]")) return;
      bindVideoEvents(media, null);
      ensureHeroAutoplay(media, null);
    });

    initAutoplayRetries();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
